import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { DashboardRedirect } from './pages/DashboardRedirect';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { TenantList } from './pages/admin/TenantList';
import { AgentSpecAdmin } from './pages/admin/AgentSpecAdmin';
import { TenantDashboard } from './pages/tenant/TenantDashboard';
import { AdvocateList } from './pages/tenant/AdvocateList';
import { AdvocateDashboard } from './pages/advocate/AdvocateDashboard';
import { ClientList } from './pages/clients/ClientList';
import { ClientForm } from './pages/clients/ClientForm';
import { ClientDetail } from './pages/clients/ClientDetail';
import { CaseForm } from './pages/cases/CaseForm';
import { CaseDetail } from './pages/cases/CaseDetail';
import { CaseView } from './pages/cases/CaseView';
import { InvoiceDetail } from './pages/invoices/InvoiceDetail';
import { ClientDashboard } from './pages/client/ClientDashboard';
import { PortalInvoiceDetail } from './pages/client/PortalInvoiceDetail';
import { TaskListPage } from './pages/tasks/TaskList';
import { PendingDocumentsPage } from './pages/documents/PendingDocumentsPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />

          {/* Dashboard redirect based on role */}
          <Route path="/dashboard" element={<ProtectedRoute><DashboardRedirect /></ProtectedRoute>} />

          {/* SPEDflow Admin routes */}
          <Route path="/admin/dashboard" element={<ProtectedRoute allowedRoles={['spedflow-admin']}><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/tenants" element={<ProtectedRoute allowedRoles={['spedflow-admin']}><TenantList /></ProtectedRoute>} />
          <Route path="/admin/agent-specs" element={<ProtectedRoute allowedRoles={['spedflow-admin']}><AgentSpecAdmin /></ProtectedRoute>} />

          {/* Tenant Admin routes */}
          <Route path="/tenant/dashboard" element={<ProtectedRoute allowedRoles={['tenant-admin']}><TenantDashboard /></ProtectedRoute>} />
          <Route path="/tenant/advocates" element={<ProtectedRoute allowedRoles={['tenant-admin']}><AdvocateList /></ProtectedRoute>} />

          {/* Advocate routes */}
          <Route path="/advocate/dashboard" element={<ProtectedRoute allowedRoles={['advocate', 'tenant-admin']}><AdvocateDashboard /></ProtectedRoute>} />

          {/* Task management routes (advocates and tenant-admins) */}
          <Route path="/tasks" element={<ProtectedRoute allowedRoles={['advocate', 'tenant-admin']}><TaskListPage /></ProtectedRoute>} />

          {/* Document management routes (advocates and tenant-admins) */}
          <Route path="/documents/pending" element={<ProtectedRoute allowedRoles={['advocate', 'tenant-admin']}><PendingDocumentsPage /></ProtectedRoute>} />

          {/* Client management routes (advocates and tenant-admins) */}
          <Route path="/clients" element={<ProtectedRoute allowedRoles={['advocate', 'tenant-admin']}><ClientList /></ProtectedRoute>} />
          <Route path="/clients/new" element={<ProtectedRoute allowedRoles={['advocate', 'tenant-admin']}><ClientForm /></ProtectedRoute>} />
          <Route path="/clients/:id" element={<ProtectedRoute allowedRoles={['advocate', 'tenant-admin']}><ClientDetail /></ProtectedRoute>} />
          <Route path="/clients/:id/edit" element={<ProtectedRoute allowedRoles={['advocate', 'tenant-admin']}><ClientForm /></ProtectedRoute>} />

          {/* Case management routes (advocates and tenant-admins) */}
          <Route path="/cases" element={<ProtectedRoute allowedRoles={['advocate', 'tenant-admin']}><CaseView /></ProtectedRoute>} />
          <Route path="/cases/new" element={<ProtectedRoute allowedRoles={['advocate', 'tenant-admin']}><CaseForm /></ProtectedRoute>} />
          <Route path="/cases/:id" element={<ProtectedRoute allowedRoles={['advocate', 'tenant-admin']}><CaseDetail /></ProtectedRoute>} />
          <Route path="/cases/:id/edit" element={<ProtectedRoute allowedRoles={['advocate', 'tenant-admin']}><CaseForm /></ProtectedRoute>} />

          {/* Invoice routes (advocates and tenant-admins) */}
          <Route path="/invoices/:id" element={<ProtectedRoute allowedRoles={['advocate', 'tenant-admin']}><InvoiceDetail /></ProtectedRoute>} />

          {/* Client portal routes */}
          <Route path="/portal/dashboard" element={<ProtectedRoute allowedRoles={['client']}><ClientDashboard /></ProtectedRoute>} />
          <Route path="/portal/invoices/:id" element={<ProtectedRoute allowedRoles={['client']}><PortalInvoiceDetail /></ProtectedRoute>} />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
